import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dismissAfter: { type: Number, default: 3000 } // 3 seconds default
  }

  connect() {
    // Auto-dismiss the alert after the specified time
    this.timeoutId = setTimeout(() => {
      this.dismiss()
    }, this.dismissAfterValue)
  }

  disconnect() {
    // Clear timeout if controller is disconnected before auto-dismiss
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  dismiss() {
    // Guard against double-dismiss
    if (this.dismissed) return
    this.dismissed = true

    // Add fade-out animation with slide-out effect
    this.element.style.transition = "opacity 0.3s ease-out, transform 0.3s ease-out"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateX(100%)"

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
